import { API_ENDPOINTS } from '@tsgecart/config';
import { adminApiFetch } from './admin-client.js';
import type { DashboardDatePreset, DashboardOverviewDto } from '../types/dashboard.js';

export interface DashboardOverviewParams {
  preset: DashboardDatePreset;
  from?: string;
  to?: string;
}

export async function fetchDashboardOverview(
  token: string,
  params: DashboardOverviewParams,
  signal?: AbortSignal,
): Promise<DashboardOverviewDto> {
  const search = new URLSearchParams({ preset: params.preset });
  if (params.preset === 'custom') {
    if (params.from) search.set('from', params.from);
    if (params.to) search.set('to', params.to);
  }
  return adminApiFetch<DashboardOverviewDto>(
    `${API_ENDPOINTS.adminDashboardOverview}?${search.toString()}`,
    { token, signal },
  );
}
